import React from 'react'
import { observer } from 'mobx-react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import QuestionsControls from './QuestionsControls'
import Slide from './Slide'
import SlidePreview from './SlidePreview'
import FilterModal from './modals/FilterModal'
import SlideSelectModal from './modals/SlideSelectModal'
import VerbatimSettingsModal from './modals/VerbatimSettingsModal'
import PresentationSettingsModal from './modals/PresentationSettingsModal'
import SlideSettingsModal from './modals/SlideSettingsModal'
import ChartSettingsModal from './modals/ChartSettingsModal'
import DerivedChartModal from './modals/DerivedChartModal'
import InheritedChartModal from './modals/InheritedChartModal'
import CrossbreakSettingsModal from './modals/CrossbreakSettingsModal'

import './ppbuilder.scss'

const PowerpointBuilder = ({ store }) => {
    const {
        handleOpenSlideSelectModal, onQuestionDragEnd, currentSlide, currentSection
    } = store

    return (
        <div>
            <div className="pp-container">
                <DragDropContext onDragEnd={onQuestionDragEnd}>
                    <div className="pp-left-container">
                        <QuestionsControls store={store} />
                    </div>

                    <div className="pp-slide-container">
                        <div>
                            <Droppable
                                key={0}
                                droppableId="add-above"
                            >
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                    >
                                        <div className={`${!currentSection && !currentSlide ? 'pp-disabled-add' : 'pp-add-slide'}`} onClick={() => handleOpenSlideSelectModal('above')}>
                                            <i className="fas fa-plus" />
                                        </div>
                                    </div>
                                )}
                            </Droppable>
                        </div>

                        <div style={{ height: '100%', width: '100%', maxWidth: 'calc(100vw - 620px)' }}>
                            <Slide store={store} />
                        </div>

                        <Droppable
                            key={0}
                            droppableId="add-below"
                        >
                            {(provided) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <div className="pp-add-slide" onClick={() => handleOpenSlideSelectModal('below')}>
                                        <i className="fas fa-plus" />
                                    </div>
                                </div>
                            )}
                        </Droppable>
                    </div>
                </DragDropContext>

                <SlidePreview store={store} />
            </div>

            <SlideSelectModal store={store} />

            <FilterModal store={store} />

            <VerbatimSettingsModal store={store} />

            <PresentationSettingsModal store={store} />

            <SlideSettingsModal store={store} />

            <ChartSettingsModal store={store} />

            <DerivedChartModal store={store} />

            <InheritedChartModal store={store} />

            <CrossbreakSettingsModal store={store} />
        </div>
    )
}

export default observer(PowerpointBuilder)
